export default __webpack_public_path__ + "static/media/perfect2.489332c7.JPG";